import React from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookmark, faHeart, faComment } from '@fortawesome/free-solid-svg-icons';
import profile from "../Images/profile.jpg"

const UserProfile = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const role = user ? user.role : 'Invité';

  const savedVideos = JSON.parse(localStorage.getItem('savedVideos')) || [];
  const likedVideos = JSON.parse(localStorage.getItem('likedVideos')) || [];
  const commentedVideos= JSON.parse(localStorage.getItem('commentedVideos')) || [];


  

  return (
    <main>
    <section className="user-profile">
      <h1 className="heading">Ton profil</h1>

      <article className="info">
        <article className="user">
          <img src={profile} alt="photo_de_profile" />
          <h3>{user ? user.login : 'Nom de l\'utilisateur'}</h3>
          <p>{role}</p>
        </article>

        <section className="box-container">
          <article className="box">
            <article className="flex">
              <i className="fas fa-bookmark"><FontAwesomeIcon icon={faBookmark} /></i>
              <article>
                <p>{savedVideos.length}</p>
                <p>vidéos sauvegardées</p>
              </article>
            </article>
            <NavLink to="#" className="purple-btn">
              voir les vidéos
            </NavLink>
          </article>

          <article className="box">
            <article className="flex">
              <i className="fas fa-heart"><FontAwesomeIcon icon={faHeart} /></i>
              <article>
                <p>{likedVideos.length}</p>
                <p>vidéos aimées</p>
              </article>
            </article>
            <NavLink to="#" className="purple-btn">
              voir les j'aime
            </NavLink>
          </article>

          <article className="box">
            <article className="flex">
              <i className="fas fa-comment"><FontAwesomeIcon icon={faComment} /></i>
              <article>
                <p>{commentedVideos.length}</p>
                <p>vidéos commentées</p>
              </article>
            </article>
            <NavLink to="#" className="purple-btn">
              voir les commentaires
            </NavLink>
          </article>
        </section>
      </article>
    </section>
  </main>
  );
};

export default UserProfile;
